<template>
  <div class="wg-row">
    <!-- Add maps api key -->
    <iframe 
        v-if="place && extended"
        :src="'https://www.google.com/maps/embed/v1/place?' 
            + (mapsCoord ? 'center='+mapsCoord+'&' : '') 
            + 'zoom=15&q=' + mapsSrc + '&key=' + mapsKey"
    ></iframe>
    <div class="wg-row com-anm22-app-white-container" style="align-items:center;flex-wrap:nowrap;">
      <img :src="$anm22.icons.getWorldIcon('placeBlack')" class="com-anm22-app-img-s wg-p-5" style="margin-right:5px;">
      <div 
          class="com-anm22-app-text-m"
          :title="$anm22.strLang(lang, 'Main', 'Sede principale')">
        {{ (place.name ? place.name + ', ' : '') + mapsAddress }}
      </div>
      <template v-if="assoc">
        <img 
            v-if="assoc.isMain"
            class="com-anm22-app-img-fixed-height-m"
            style="margin-left:auto;"
            :src="$anm22.icons.getWorldIcon('pinToTop')"
            :title="$anm22.strLang(lang, 'Main site', 'Sede principale')"> 
        <img 
            v-else
            class="com-anm22-app-img-fixed-height-m"
            :style="'margin-left:auto;' + (pinToTop ? 'cursor:pointer;' : '')"
            :src="$anm22.icons.getWorldIcon('pinToTopOff')"
            @click="pinToTop ? $emit('pinToTop', place.idWorldPlace) : ''"
            :title="pinToTop 
                ? $anm22.strLang(lang, 'Set as main', 'Imposta come sede principale')
                : $anm22.strLang(lang, 'Secondary site', 'Sede secondaria')">
      </template>
      <img 
          v-if="editFn"
          class="com-anm22-app-img-fixed-height-m"
          style="margin-left:12px;"
          :src="$anm22.icons.getWorldIcon('edit')" 
          :title="$anm22.strLang(lang, 'Edit place', 'Modifica luogo')"
          @click="editFn(place.idWorldPlace)"
      >
      <img 
          v-if="deleteFn"
          class="com-anm22-app-img-fixed-height-m"
          style="margin-left:5px;"
          :src="$anm22.icons.getWorldIcon('deleteBin')" 
          :title="$anm22.strLang(lang, 'Delete place', 'Elimina luogo')"
          @click="deleteFn(place.idWorldPlace)"
      >
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  props: {
    place: Object,
    assoc: Object,
    pinToTop: Boolean,
    extended: Boolean,
    editFn: Function, 
    deleteFn: Function
  },
  computed: {
    ...mapState({
      lang: state => state.lang,
      user: state => state.auth.user
    }),
    mapsKey() {
      return process.env.VUE_APP_GMAPS_API_KEY;
    },
    mapsCoord() {
      if(this.place && this.place.latitude && this.place.longitude) {
        return this.place.latitude+','+this.place.longitude;
      } else {
        return null;
      }
    },
    mapsAddress() {
      return this.$anm22.getAddressFromPlace(this, this.place);
    },
    mapsSrc() {
      return this.mapsAddress.replace(/[, ]/g, '+');
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
